import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import CustomDragLayer from './CustomDragLayer';

// Custom Preview Drag Layer - How many selected tracks 
function ConnectedCustomDragLayerWrapper({ layer, items }) {
  if (!document.getElementById(layer)) {
    console.warn(`Warning: To be able to use a custom layer, the index.html need a div with a id '${layer}'`);
  }
  return (
    <CustomDragLayer layer={layer} items={items} />
  )
}

ConnectedCustomDragLayerWrapper.propTypes = {
  layer: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired
}

const CustomDragLayerWrapper = connect( state => ({ items: state.dragItems }) )(ConnectedCustomDragLayerWrapper);

export default CustomDragLayerWrapper;
